import HttpService from '../../services/http/httpService';
import config from '../../config';

const paramsTabla = ({ colFilters, ...params }, extra = {}) => {
  const hayFiltros = colFilters && Object.keys(colFilters).length > 0;
  return { ...params, ...extra, colFilters: hayFiltros ? JSON.stringify(colFilters) : undefined };
};

/** Cliente genérico de las tablas estándar en servidor: `ruta/tabla`, `/facetas` y `/exportar`. */
class TablaServidorApi extends HttpService {
  async tabla(ruta, params) {
    return this.get(`${ruta}/tabla`, { params: paramsTabla(params) });
  }

  async facetas(ruta, { columna, ...params }) {
    return this.get(`${ruta}/tabla/facetas`, { params: paramsTabla(params, { columna }) });
  }

  async exportar(ruta, { columnas, ...params }) {
    return this.get(`${ruta}/tabla/exportar`, {
      params: paramsTabla(params, { columnas: columnas?.join(',') }),
      responseType: 'blob',
      silent: true,
    });
  }

  // Excel de una tabla cuyos datos ya están en el panel (columnas = [{ id, label }]).
  async excelLocal(nombre, columnas, filas) {
    return this.post(
      'tabla-excel',
      { nombre, columnas, filas },
      { responseType: 'blob', silent: true },
    );
  }
}

export default new TablaServidorApi(config.REACT_APP_NODE_API);
